// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


/* ✅ Screener Table Styles */
.table-container {
  padding: 2rem;
  font-family: sans-serif;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

th, td {
  border: 1px solid #ccc;
  padding: 0.75rem;
  text-align: left;
}

th {
  background-color: #f8f8f8;
}

tbody tr:hover {
  background-color: #f0f8ff;
}

/* Dashboard Builder - Resize Handle Styling */
.react-resizable-handle {
  width: 20px !important;
  height: 20px !important;
  background-color: rgba(59, 130, 246, 0.3) !important;
  background-image:
    linear-gradient(135deg, transparent 40%, rgba(59, 130, 246, 0.6) 40%, rgba(59, 130, 246, 0.6) 50%, transparent 50%),
    linear-gradient(135deg, transparent 40%, rgba(59, 130, 246, 0.6) 40%, rgba(59, 130, 246, 0.6) 50%, transparent 50%);
  background-size: 6px 6px;
  background-position: 0 0, 3px 3px;
  border-radius: 0 0 4px 0;
  transition: all 0.2s ease;
}

.react-resizable-handle:hover {
  background-color: rgba(59, 130, 246, 0.5) !important;
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.6);
}

.react-resizable-handle-se {
  bottom: 0;
  right: 0;
  cursor: se-resize;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oDAAoD;EACpD;;uHAEqH;EACrH,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/* ✅ Screener Table Styles */\n.table-container {\n  padding: 2rem;\n  font-family: sans-serif;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\nth, td {\n  border: 1px solid #ccc;\n  padding: 0.75rem;\n  text-align: left;\n}\n\nth {\n  background-color: #f8f8f8;\n}\n\ntbody tr:hover {\n  background-color: #f0f8ff;\n}\n\n/* Dashboard Builder - Resize Handle Styling */\n.react-resizable-handle {\n  width: 20px !important;\n  height: 20px !important;\n  background-color: rgba(59, 130, 246, 0.3) !important;\n  background-image:\n    linear-gradient(135deg, transparent 40%, rgba(59, 130, 246, 0.6) 40%, rgba(59, 130, 246, 0.6) 50%, transparent 50%),\n    linear-gradient(135deg, transparent 40%, rgba(59, 130, 246, 0.6) 40%, rgba(59, 130, 246, 0.6) 50%, transparent 50%);\n  background-size: 6px 6px;\n  background-position: 0 0, 3px 3px;\n  border-radius: 0 0 4px 0;\n  transition: all 0.2s ease;\n}\n\n.react-resizable-handle:hover {\n  background-color: rgba(59, 130, 246, 0.5) !important;\n  box-shadow: 0 0 8px rgba(59, 130, 246, 0.6);\n}\n\n.react-resizable-handle-se {\n  bottom: 0;\n  right: 0;\n  cursor: se-resize;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
